import React, { lazy } from 'react'
import HorizontalCard from '../HorizontalCard'
import { EditableBadge, PDFBadge, PublishedBadge, SubmittedBadge } from '../../Badge'
import { attachmentDefaultJpg } from '../../../images'
import { useFlagsContext } from '../../../providers'
import { attachmentWorkflow, FLAGS, sessionStates } from '../../../config'
import useExhibitorMutation from '../../../components/dashboard/hooks/useExhibitorMutation'

const ArchiveActions = lazy(() => import('../../buttons/ArchiveActionsButtons'))

export default function HorizontalDLRCard({
  data,
  basePath,
  showArchiveButton,
  booth,
  updateProfile,
  isLocked,
  headingLevel = 'h3',
}) {
  const { [FLAGS.ARCHIVE_ACTIONS]: archiveActionsFlag } = useFlagsContext()
  const { mutateExhibitor } = useExhibitorMutation()
  const dlrData = { ...data, imgSrc: attachmentDefaultJpg }

  const removeAttachment = async (id) => {
    const updatedDLR = booth.downloadableResources.filter((dlr) => dlr.id !== id)

    // We need to clear the downloadable resources to update the content
    if (updatedDLR.length) {
      await mutateExhibitor({
        id: booth.id,
        locale: booth.contentLocale,
        downloadableResources: [],
      })
    }
    const updatedBooth = await mutateExhibitor({
      id: booth.id,
      locale: booth.contentLocale,
      downloadableResources: updatedDLR.length ? updatedDLR?.map((dlr) => dlr.id) : [],
    })

    updateProfile(updatedBooth)
  }

  const isWorkflow = data?.visibility?.status === sessionStates.WORKFLOW
  const isDraft = isWorkflow && data?.visibility?.workflowState === attachmentWorkflow.state.draft
  const isSubmitted = isWorkflow && data?.visibility?.workflowState === attachmentWorkflow.state.review
  const isPublished = data?.visibility?.status === sessionStates.PUBLISHED

  return (
    <HorizontalCard
      key={data?.id}
      headingLevel={headingLevel}
      badges={[
        <PDFBadge key="pdf" />,
        isDraft && <EditableBadge key="draft" />,
        isSubmitted && <SubmittedBadge key="submitted" />,
        isPublished && <PublishedBadge key="published" />,
      ]}
      data={dlrData}
      description={data.description}
      to={`${basePath}${data?.id}`}
      contentId={data.id}
      isLocked={isLocked}
      actions={
        showArchiveButton && archiveActionsFlag.isOn && <ArchiveActions data={dlrData} removeData={removeAttachment} />
      }
    />
  )
}
